'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import Script from 'next/script';

export default function HubspotChat() {
  const pathname = usePathname();

  const isAllowedRoute =
    pathname === '/' ||
    pathname.startsWith('/catalog') ||
    pathname.startsWith('/classes');

  useEffect(() => {
    if (isAllowedRoute) return;

    const removeHubspotElements = () => {
      const selectors = [
        'iframe[id*="hubspot"]',
        'iframe[class*="hubspot"]',
        '[id*="hubspot"]',
        '[class*="hubspot"]',
        '[data-hs-widget]',
        '.hs-chat-widget',
        '#hubspot-messages-iframe-container',
        '#hubspot-conversations-inline-parent',
      ];

      document.querySelectorAll(selectors.join(',')).forEach((el) => {
        if (el.tagName !== 'SCRIPT') {
          el.remove();
        }
      });

      document.body.classList.remove('hs-messages-widget-open');
      document.body.classList.remove('hs-messages-widget-active');
      document.documentElement.classList.remove('hs-messages-widget-open');
      document.documentElement.classList.remove('hs-messages-widget-active');
    };

    removeHubspotElements();

    const timeout = setTimeout(removeHubspotElements, 300);
    return () => clearTimeout(timeout);
  }, [pathname, isAllowedRoute]);

  if (!isAllowedRoute) return null;

  return (
    <Script
      id="hs-script-loader"
      src="//js-na2.hs-scripts.com/245668306.js"
      strategy="afterInteractive"
    />
  );
}